import * as React from 'react'

import LoadingSpinner from '../../icons/loadingSpinner/'

import * as styles from './preloader.module.css'

const Preloader = () => {
  return (
    <div className={styles.loading}>
      <LoadingSpinner width="50" height="50" strokeColor="hsl(0, 0%, 66%)" />
    </div>
  )
}

export default Preloader



// WEBPACK FOOTER //
// ./client/components/productList/preloader/preloader.tsx